import { Component, HostBinding, OnInit } from '@angular/core';
import { ElementsService } from 'dbweb-core';
import { CardSize, IndexService } from '../index.service';

@Component({
	selector: 'common-notice',
	templateUrl: './notice.component.html',
	styleUrls: ['./notice.component.scss']
})
export class NoticeComponent implements OnInit {
	@HostBinding('class.c-index-notice') hostClass = true;
	navName = 'notice';
	navSize: CardSize;

	constructor(public svr: IndexService, public eles: ElementsService) {
		this.navSize = this.svr.userSetting.Cards.find(x => x.Type === this.navName).Size;
	}

	ngOnInit() {
		this.svr.initNotice();
	}
	get hasNotReadNoticeCount() {
		if (this.svr.notice) {
			return this.svr.notice.filter(v => !v.IsReaded).length;
		}
		return 0;
	}
}
